export default "__VITE_ASSET__BvjeFSLs__"